Vue.component('feedback', {
    props: {
        params: {
            
        },
        
    },
    data () {
        return {
            showform: false,
            feedbackresult: false
        }
    },
    methods: {
        show () {
            this.showform = true;
            this.$nextTick(function() {
                document.getElementById('feedback_email').focus();
            })
            
        },
        async send () {
            let message = document.getElementById('feedback_issue').value;
            if (!message) {
                alert("Please describe your feedback/issue");
                document.getElementById('feedback_issue').focus();
                return
            } 
            let b = document.getElementById('feedback_submit');
            b.innerHTML = "Sending...";
            b.disabled = true;
            let sender = document.getElementById('feedback_email').value;
            if (!sender) {sender = "z@next-iteration.net";}



            let obja = new FormData;
            obja.append('action', 'slide_save_search');
            obja.append('params', this.params);
            let dataa = await axios.post(axios_ajax.ajaxurl, obja);
            let savekey = String(dataa.data).trim();
            let url = location.protocol + '//' + location.host + location.pathname + "?saved=" + savekey;
            message = message + "\n" + url
            let params = this.params;
            params.sender = sender;
            params.message = message;
            let obj = new FormData;
            obj.append('action', 'slide_send_feedback');
            obj.append('params', params);
            obj.append('sender', sender);
            obj.append('message', message);
            let data = await axios.post(axios_ajax.ajaxurl, obj);
            
            this.showform = false;
            b.innerHTML = "Send";
            b.disabled = false;
            this.feedbackresult = "Thanks! Your message has been sent";
        }
    }

});